import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { VpHookFormSelect, VpHookFormColorInput } from '../..';
import { useFetchPluginById, useFetchPluginOptions } from '../../../hooks';
import { VpPluginFontFamilySelect } from './VpPluginFontFamilySelect';

import config from '../../../config';

export const VpPluginTextDescriptionInputs = ({ disabled }) => {
  const { data } = useFetchPluginById();
  const { data: optionsData } = useFetchPluginOptions({ enabled: config?.pluginFontSizeEnabled });

  return (
    <Stack direction="row" alignItems="end" spacing={1}>
      <VpPluginFontFamilySelect
        smallLabel
        name="descriptionFont"
        disableHelperText
        defaultValue={data?.styles?.descriptionFont}
        disabled={disabled}
        selectDefault
      />
      {config?.pluginFontSizeEnabled && (
        <VpHookFormSelect
          options={optionsData?.descriptionFontSizes}
          required
          name="descriptionFontSize"
          disableHelperText
          defaultValue={data?.styles?.descriptionFontSize}
          disabled={disabled}
          selectDefault
        />
      )}
      <VpHookFormColorInput
        required
        name="descriptionFontColor"
        disableHelperText
        defaultValue={data?.styles.descriptionFontColor}
        disabled={disabled}
      />
    </Stack>
  );
};

VpPluginTextDescriptionInputs.propTypes = {
  disabled: PropTypes.bool
};

export default VpPluginTextDescriptionInputs;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginTextDescriptionInputs.jsx